import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export const SortableSection = ({ id, active, label, onClick }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    zIndex: isDragging ? 10 : 'auto',
  };
  return (
    <li ref={setNodeRef} style={style} className="flex items-center gap-1">
      <button
        type="button"
        {...attributes}
        {...listeners}
        className="p-1 rounded cursor-grab active:cursor-grabbing touch-none transition text-black/30 hover:text-black"
        aria-label="Trascina"
      >
        <GripVertical size={14} />
      </button>
      <button
        onClick={onClick}
        className={`flex-1 text-left px-2 py-2 rounded-lg font-bold text-sm transition ${active ? 'bg-black text-white' : 'hover:bg-black/5 text-black'}`}
      >
        {label}
      </button>
    </li>
  );
};

export default SortableSection;
